let knownErrors = {
   'unknown': async (error) => {
      console.log('Error', error)
      if (error.code) {
         $notify('error', `Error - ${error.code}`, error.msg)
      } else {
         $notify('error', 'Unknown Error', 'An Error has Occured')
      }
   },
   '5003': async (error) => {
      $notify('error', 'Token Expired', 'Please log in again to get a new token')
      window.location.href = '/';
   },
   '5002': async (error) => {
      $notify('error', 'User not Found', 'Please log in again.')
      window.location.href = '/';
   },
}

let jsErrors = {
   'TypeError': async (error) => {
      if (error.message === 'Failed to fetch'){
         $notify('error', 'Connection Error', 'Failed to connect to the server')
      }else{
         $notify('error', 'Type Error', error.message)
      }
   },
   'unknown': async (error) => {
      $notify('error', 'Unknown Error', 'An Error has Occured')
   },
}

export default class ErrorHandler {
   constructor(router) {
      this.router = router;
   }

   async handleError(err) {
      if (err && err.error && err.error.code) {
         let code = err.error.code.toString()
         let errAction = knownErrors[code]

         if (errAction) {
            await errAction(err.error)
         } else {
            await knownErrors['unknown'](err.error)
         }
      } else {
         console.log('Error',err)
         if (err.error) {
            if (err.error.code) {
               $notify('error', `Error - ${err.error.code}`, err.error.msg)
            } else {
               $notify('error', 'Error', err.error.msg)
            }
         } else if (err.result && err.result.error) {
            err = err.result.error
            if (err.code == 422) {
               let message = ''
               for (let i = 0; i < err.details.error_fields.length; i++) {
                  let field = Object.entries(err.details.error_fields[i])[0];

                  console.log(field)
                  message += `<b>${field[0]}</b> - ${field[1].message} </br>`
               }

               $notify('error', 'Validation Error', message)
            }
         } else {
            let name = err.name.toString()
            let errAction = jsErrors[name]

            if (errAction) {
               await errAction(err)
            } else {
               $notify('error', 'Error', 'An Error Occured.')
            }
         }
      }
   }
}